import axios from 'axios';

const httpGetAccountLookup = (userId, payload) => {
  return axios.post(`/api/v2/account/lookup?userId=${userId}`, { ...payload });
};

const httpSaveGmailDraft = (templateId, authCode) => {
  return axios.post(`/api/v2/export/mail/GMAIL/${templateId}`, { authCode });
};

const httpSaveOutlookWebDraft = (templateId, authCode) => {
  return axios.post(`/api/v2/export/mail/OUTLOOK/${templateId}`, { authCode });
};

const httpSavetMailchimpDraft = (templateId, authCode) => {
  return axios.post(`/api/v2/export/mail/MAILCHIMP/${templateId}`, {
    authCode,
  });
};

const httpExportToWebhook = (templateId, webhookUrl, webhookHeaders) => {
  return axios.post(`/api/v2/export/mail/WEBHOOK/${templateId}`, {
    webhookUrl,
    webhookHeaders,
  });
};

const httpExportToZapeir = (templateId, webhookUrl) => {
  return axios.post(`/api/v2/export/mail/ZEPIER/${templateId}`, {
    webhookUrl,
  });
};

const httpExportToMailJet = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/MAILJET/${templateId}`, {
    ...payload,
  });
};

const httpExportToSendGrid = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/SENDGRID/${templateId}`, {
    ...payload,
  });
};

const httpExportToMake = (templateId, makeWebhookUrl) => {
  return axios.post(`/api/v2/export/mail/MAKE/${templateId}`, {
    makeWebhookUrl,
  });
};

const httpExportToBlueShift = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/BLUESHIFT/${templateId}`, {
    ...payload,
  });
};

const httpSavetZohoMailDraft = (templateId, authCode, zohoMailRegion) => {
  return axios.post(`/api/v2/export/mail/ZOHOMAIL/${templateId}`, {
    authCode,
    region: zohoMailRegion,
  });
};

const httpSavetZohoCampaignDraft = (
  templateId,
  authCode,
  zohoCampaignRegion,
) => {
  return axios.post(`/api/v2/export/mail/ZOHOCAMPAIGN/${templateId}`, {
    authCode,
    region: zohoCampaignRegion,
  });
};

const httpDownloadOftFile = (templateId) => {
  return axios.get(`/api/v2/export/mail/outlook/app/oft/${templateId}`);
};

const httpDownloadEmltplFile = (templateId) => {
  return axios.get(`/api/v2/export/mail/outlook/app/emltpl/${templateId}`);
};

const httpExportToKlaviyo = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/KLAVIYO/${templateId}`, {
    ...payload,
  });
};

const httpExportToIContact = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/ICONTACT/${templateId}`, {
    ...payload,
  });
};

const httpExportToBrevo = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/BREVO/${templateId}`, {
    ...payload,
  });
};

const httpExportToEcoMail = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/ECOMAIL/${templateId}`, {
    ...payload,
  });
};

const httpExportToConstantContact = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/CONSTANT_CONTACT/${templateId}`, {
    ...payload,
  });
};

const httpExportToDotdigital = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/DOTDIGITAL/${templateId}`, {
    ...payload,
  });
};

const httpExportToSendwithus = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/SENDWITHUS/${templateId}`, {
    ...payload,
  });
};

const httpExportToSendpulse = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/SENDPULSE/${templateId}`, {
    ...payload,
  });
};

const httpExportToRule = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/RULE/${templateId}`, {
    ...payload,
  });
};

const httpExportToMoosend = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/MOOSEND/${templateId}`, {
    ...payload,
  });
};

const httpExportToPabbly = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/PABBLY/${templateId}`, {
    ...payload,
  });
};

const httpExportToSelzy = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/SELZY/${templateId}`, {
    ...payload,
  });
};

const httpExportToCleverReach = (templateId, payload) => {
  return axios.post(`/api/v2/export/mail/CLEVER_REACH/${templateId}`, {
    ...payload,
  });
};

const httpExportToOneSignal = (templateId, payload) => {
  return axios.post(`api/v2/export/mail/ONESIGNAL/${templateId}`, {
    ...payload,
  });
};

const httpExportToElasticEmail = (templateId, payload) => {
  return axios.post(`api/v2/export/mail/ELASTICEMAIL/${templateId}`, {
    ...payload,
  });
};

export {
  httpGetAccountLookup,
  httpSaveGmailDraft,
  httpSaveOutlookWebDraft,
  httpSavetMailchimpDraft,
  httpExportToWebhook,
  httpExportToZapeir,
  httpExportToMailJet,
  httpExportToSendGrid,
  httpExportToMake,
  httpExportToBlueShift,
  httpSavetZohoMailDraft,
  httpSavetZohoCampaignDraft,
  httpDownloadOftFile,
  httpDownloadEmltplFile,
  httpExportToKlaviyo,
  httpExportToIContact,
  httpExportToBrevo,
  httpExportToEcoMail,
  httpExportToConstantContact,
  httpExportToDotdigital,
  httpExportToSendwithus,
  httpExportToSendpulse,
  httpExportToRule,
  httpExportToMoosend,
  httpExportToPabbly,
  httpExportToSelzy,
  httpExportToCleverReach,
  httpExportToOneSignal,
  httpExportToElasticEmail,
};
